// extracted by mini-css-extract-plugin
export default {"modalActionsRow":"stockRequestComponents_modalActionsRow__gWJgL","modalSingleActionRow":"stockRequestComponents_modalSingleActionRow__4ImaJ"};